import 'css-chunksrc/client/scenes/assignToTask/projectSelection/zones/zone/styles.scss';export default {
  "header": "_header_gg67b_1",
  "icon": "_icon_gg67b_10",
  "name": "_name_gg67b_17",
  "projects": "_projects_gg67b_24"
};